<template>
    <div v-if="display" class="row">
        <div class="col">
            <SubSection title="What does financial advice cost?" :show-help="false">
                <p>In short, it depends on the advice needed. As an example, retirement advice on selecting a mix of
                    products, providers and suitable investments may be around 1-2% of the value of your pots with a minimum
                    fixed cost at lower pot levels.</p>
                <p>To help, advisers offer a free or low cost meeting to start with. The Government also allows people in
                    defined contribution pension schemes to withdraw up to &pound;500 tax free from their pension pot to pay
                    towards retirement advice, if your pension provider allows this.</p>
            </SubSection>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysGenericCostOfFinancialAdvice;
});

</script>
